import { Injectable, signal } from '@angular/core';
import { PurchaseSuccessData } from '../models/purchase-success.model';

@Injectable({ providedIn: 'root' })
export class PurchaseSuccessService {
  readonly data = signal<PurchaseSuccessData | null>(null);

  show(payload: PurchaseSuccessData): void {
    this.data.set(payload);
  }

  close(): void {
    this.data.set(null);
  }
}
